export default {
  EMT_RULES: 'rules',
  EMT_WIN_BIG: 'winBig',
  EMT_WIN_REGULAR: 'winRegular',
  EMT_PROVABLY_FAIR: 'provablyFair',
}
